var dropdownWrapper = require('./dropdown-wrapper');
var dropdownItemWrapper = require('vue-tables-2/compiled/modules/dropdown-item-wrapper');

module.exports = function(h) {
    return classes => {
        var cols = this.columns.map(column => {
            return dropdownItemWrapper(
                h,
                classes,
                <a
                    class={classes.dropdown.item}
                    on-click={this.toggleColumn.bind(this, column)}
                >
                    <input
                        type="checkbox"
                        value={column}
                        disabled={this._onlyColumn(column)}
                        on-change={this.toggleColumn.bind(this, column)}
                        checked={this.allColumns.includes(column)}
                    />
                    <span class="m-l-sm">{this.getHeading(column)}</span>
                </a>,
            );
        });

        return (
            <div
                class={`${classes.dropdown.container} ${
                    classes.right
                } VueTables__columns-dropdown`}
            >
                <button
                    type="button"
                    class={`btn ${classes.dropdown.trigger} btn-fw white`}
                    data-toggle="dropdown"
                >
                    {this.display('columns')}
                    <span class={`${classes.icon} ${classes.small}`}>
                        <i class={classes.dropdown.caret} />
                    </span>
                </button>

                {dropdownWrapper.call(this, h, classes, cols)}
            </div>
        );
    };
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/modules/columns-dropdown.jsx